import * as types from '../../../constants/actionTypes';
// import * as auth from '../../../../tools/auth0.cred';
import * as api from '../../../tools/apiConfig';
// import jQuery from 'jquery';
import axios from 'axios';
// import constant from '../../../constants/constant'
import { history } from '../../../store/configureStore';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as url from '../../../tools/config';
import openSocket from 'socket.io-client';
const socket = openSocket(url.getURLForServer(process.env.REACT_APP_NODE_ENV).SOCKET_URL);
// import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
const google = window.google;

export function addUser(userdata, props) {
	return function (dispatch, getState) {
		axios.post(api.ADD_USER, JSON.stringify(userdata), {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
					props.history.push({
						pathname: '/specialist/my-settings',
						state: {
							selected: 'addUser'
						}
					})
					console.log('called:', props)
					response.data.data.userData.success = true;
					return dispatch({ type: types.ADD_USER, adminUserData: response.data.data.userData });
				}
				else {
					toast.error(response.data.message);
					response.data.data = {};
					response.data.data.userData = {};
					response.data.data.userData.success = false;
					return dispatch({ type: types.ADD_USER, adminUserData: response.data.data ? response.data.data.userData : {} });
				}
			})
			.catch(function (error) {
				toast.error(error);
			});
	}
}

export function updateUser(userdata, props) {
	return function (dispatch, getState) {
		axios.post(api.UPDATE_USER, JSON.stringify(userdata), {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					props.history.push({
						pathname: '/specialist/my-settings',
						state: {
							selected: 'addUser'
						}
					})
					axios.post(api.GET_USER_BY_ID, { userId: userdata.userId }, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {
								response.data.data.success = true;
								return dispatch({ type: types.GET_USER_BY_ID, userData: response.data.data })
							} else {
								toast.error(response.data.message)
								response.data.data.success = false;
								return dispatch({ type: types.GET_USER_BY_ID, userData: response.data.data })
							}
						})
						.catch(function (error) {
						});
					toast.info(response.data.message);
					response.data.data.userData.success = true;
					return dispatch({ type: types.UPDATE_USER, adminUserUpdatedData: response.data.data.userData });
				}
				else {
					toast.error(response.data.message);
					response.data.data = {};
					response.data.data.userData = {};
					response.data.data.userData.success = false;
					return dispatch({ type: types.UPDATE_USER, adminUserUpdatedData: response.data.data ? response.data.data.userData : {} });
				}
			})
			.catch(function (error) {
				toast.error(error);
			});
	}
}
export function getUserList(data) {
	return function (dispatch, getState) {
		axios.post(api.GET_USER_LIST, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						response.data.data.success = true;
						return dispatch({ type: types.GET_USER_LIST, userListData: response.data.data })
					}
				} else {
					response.data.data.success = false;
					return dispatch({ type: types.GET_USER_LIST, userListData: response.data.data })
				}
			})
			.catch(function (error) { });
	}
}
export function CreateCommition(data) {
	return function (dispatch, getState) {
		axios.post(api.CREATE_COMMISSION, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
                      //  toast.success(response.data.message);
						// response.data.data.success = true;
						// return dispatch({ type: types.GET_USER_LIST, userListData: response.data.data })
					}
				} else {
                    toast.error(response.data.message);
					// response.data.data.success = false;
					// return dispatch({ type: types.GET_USER_LIST, userListData: response.data.data })
				}
			})
			.catch(function (error) { });
	}
}


export function TransactionFee(data) {
	return function (dispatch, getState) {
		axios.post(api.TRANSACTION_FEE, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
                  //  toast.success(response.data.message);
					// if (data) {
					// 	response.data.data.success = true;
					// 	return dispatch({ type: types.GET_USER_LIST, userListData: response.data.data })
					// }
				} else {
                    toast.error(response.data.message);
					// response.data.data.success = false;
					// return dispatch({ type: types.GET_USER_LIST, userListData: response.data.data })
				}
			})
			.catch(function (error) { });
	}
}


export function SubmitInvoiceDay(data) {
	return function (dispatch, getState) {
		axios.post(api.SUBMIT_INVOICE_DAY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
                    toast.success(response.data.message);
					// if (data) {
					// 	response.data.data.success = true;
					// 	return dispatch({ type: types.GET_USER_LIST, userListData: response.data.data })
					// }
				} else {
                    toast.error(response.data.message);
					// response.data.data.success = false;
					// return dispatch({ type: types.GET_USER_LIST, userListData: response.data.data })
				}
			})
			.catch(function (error) { });
	}
}



export function deleteUser(userObject, userId) {
	return function (dispatch, getState) {
		var data = {
			userId: userId
		}
		axios.post(api.DELETE_USER, { userId: userId }, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					let message = response.data.message;
					toast.info(message);
					if (localStorage.getItem('userType') != 'specialist') {
						axios.post(api.GET_USER_LIST, userObject, {
							headers: {
								'Content-Type': 'application/json',
								'Authorization': 'Bearer ' + localStorage.token
							}
						})
							.then(function (response) {
								if (response.data.code == 200) {
									toast.info(message)
									response.data.data.success = true;
									return dispatch({ type: types.GET_USER_LIST, userListData: response.data.data })
								} else {
									response.data.data.success = false;
									return dispatch({ type: types.GET_USER_LIST, userListData: response.data.data })
								}
							})
							.catch(function (error) {
							});
					}
					else {
						let specialistId = localStorage.getItem('userId');
						let object = {

							specialistId: specialistId
						}
						axios.post(api.GET_SPECIALISTS_ASSISTANT_LIST, object, {
							headers: {
								'Content-Type': 'application/json',
								'Authorization': 'Bearer ' + localStorage.token
							}
						})

							.then(function (response) {
								if (response.data.code == 200) {
									if (data) {
										// response.data.data.specialists = data.user;
										// response.data.data.per_page = data.per_page;

										return dispatch({ type: types.GET_SPECIALISTS_ASSISTANT_LIST, specialistListAssistant: response.data.data })
									}
								} else if (response.data.code == 402) {
									localStorage.clear();
									history.push('/');
									toastr.error(response.data.message);
								}
							})
							.catch(function (error) {
							});
					}

				} else {

				}

			})
			.catch(function (error) {
			});
	}
}

export function getUserById(userId) {
	return function (dispatch, getState) {
		axios.post(api.GET_USER_BY_ID, { userId: userId }, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					response.data.data.success = true;
					return dispatch({ type: types.GET_USER_BY_ID, userData: response.data.data })
				} else {
					toast.error(response.data.message)
					response.data.data.success = false;
					return dispatch({ type: types.GET_USER_BY_ID, userData: response.data.data })
				}
			})
			.catch(function (error) {
			});
	}
}


export function uploadAdminUserImage(data) {
	return function (dispatch, getState) {
		const formdata = new FormData();
		formdata.append('file', data.file);
		formdata.append('userId', data.userId);
		axios.post(api.UPLOAD_ADMIN_IMAGE, formdata, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token

			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					// return dispatch({ type: types.GET_PATIENT_IMAGE, latestPatientImage: response.data.data })
					let user = JSON.parse(localStorage.getItem('user'));
					// user.adminImage = response.data.data;
					localStorage.setItem('user', JSON.stringify(user));
					toast.info(response.data.message);
					let
						userId = !user.assistId ? localStorage.getItem('userId') : user.assistId

					axios.post(api.GET_USER_BY_ID, { userId: userId }, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {
								let user = JSON.parse(localStorage.getItem('user'));
								user.adminImage = response.data.data.adminProfileImage;
								user.image = response.data.data.adminProfileImage;
								localStorage.setItem('user', JSON.stringify(user));
								response.data.data.success = true;

								return dispatch({ type: types.GET_USER_BY_ID, userData: response.data.data })
							} else {
								toast.error(response.data.message)
								response.data.data.success = false;
								return dispatch({ type: types.GET_USER_BY_ID, userData: response.data.data })
							}
						})
						.catch(function (error) {
						});
				} else if (response.data.code == 401) {
					toast.error(response.data.message);

				}
				else {
					localStorage.clear();
					history.push('/');
					toast.error(response.data.message);
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}
}


export function deleteImageProfile(data) {

	return function (dispatch, getState) {
		axios.post(api.DELETE_PROFILE_IMAGE, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		}).then(function (response) {
			if (response.data.code == 200) {
				let user = JSON.parse(localStorage.getItem('user'));
				localStorage.setItem('user', JSON.stringify(user));
				toast.info(response.data.message);
				let
					userId = !user.assistId ? localStorage.getItem('userId') : user.assistId


				axios.post(api.GET_USER_BY_ID, { userId: userId }, {
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + localStorage.token
					}
				})
					.then(function (response) {
						if (response.data.code == 200) {
							let user = JSON.parse(localStorage.getItem('user'));
							user.adminImage = response.data.data.adminProfileImage;
							user.image = response.data.data.adminProfileImage;
							localStorage.setItem('user', JSON.stringify(user));
							response.data.data.success = true;

							return dispatch({ type: types.GET_USER_BY_ID, userData: response.data.data })
						} else {
							toast.error(response.data.message)
							response.data.data.success = false;
							return dispatch({ type: types.GET_USER_BY_ID, userData: response.data.data })
						}
					})
					.catch(function (error) {
					});
			}
		})
			.catch(function (error) {
			});
	}
}

export function getPaymentConfig() {
    let obj = {
        "data":"string"
    }
	return function (dispatch, getState) {
		axios.post(api.GET_PAYMENT_CONFIG, obj, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
				
                        response.data.data.success = true;
                        // toast.info(response.data.message);
						return dispatch({ type: types.GET_PAYMENT_CONFIG, paymentConfigData: response.data.data })
					
				} else {
                    response.data.data.success = false;
                    toast.error(response.data.message);
					// return dispatch({ type: types.GET_PAYMENT_CONFIG, paymentConfigData: response.data.data })
				}
			})
			.catch(function (error) { });
	}
}